export const ID_PRESUPUESTO_PENDIENTE = 0
export const ID_PRESUPUESTO_CONFIRMADO = 1
export const ID_PRESUPUESTO_PAGADO = 2
export const ID_PRESUPUESTO_EN_PREPARACION = 3

export const MAX_CARACTERES_DESCRIPCION = 250
export const MAX_DIAS_ENTREGA = 365
